import { useSelector } from 'react-redux';
import useFeeds from '../../../../hooks/feed/useFeed';
import DataGrid from '../../../table/DataGrid';
import TextLog from '../../../text/TextLog';
import IconTooltipButton from '../../../button/IconTooltipButton';
import FormatDate from '../../../date/FormatDate';
import StatusChip from '../../DataEntry/components/StatusChip/StatusChip';

const List = ({ onModal }) => {
  const permissions = useSelector((state) => state?.session?.permissions?.feed || {});
  const list = useSelector((state) => state?.feed?.list || []);
  const totalList = useSelector((state) => state?.feed?.totalList || 0);
  const { isLoadingList } = useFeeds();

  const columnsTable = useSelector((state) => state?.datatable?.feed?.columnsTable || []);
  const rowsPerPage = useSelector((state) => state?.datatable?.feed?.rowsPerPage || 100);
  const skip = useSelector((state) => state?.datatable?.feed?.skip || 0);

  const getType = (status) => {
    switch (status) {
      case 'Draft':
        return 'error';
      case 'Scheduled':
        return 'active';
      case 'Expired':
        return 'disabled';
      default:
        return 'done';
    }
  };

  return (
    <>
      <DataGrid
        id='feed'
        rows={list
          .sort((a, b) => new Date(b.pusblishedAt) - new Date(a.pusblishedAt))
          .map((row) => {
            return {
              ...row,
              log: <TextLog updatedAt={row.updatedAt} updatedBy={row.updatedBy} />,
              viewRoles: row?.viewRoles?.map((role) => role?.name).join(', '),
              viewYearLevels: row?.viewYearLevels?.map((year) => year?.name).join(', '),
              pusblishedAt: row?.pusblishedAt ? (
                <FormatDate date={row?.pusblishedAt} pattern='dd/MMM/yyyy HH:mm a' />
              ) : null,
              expireAt: row?.expireAt ? <FormatDate date={row?.expireAt} /> : null,
              status: <StatusChip content={row.status} type={getType(row.status)} />,
              postType: row?.postType?.label,
              actions: (
                <div className='flex items-center gap-1 items-center justify-center'>
                  {permissions?.preview && (
                    <IconTooltipButton
                      id={`preview-${row._id}`}
                      disabled={isLoadingList}
                      title='Preview'
                      icon='expand-alt'
                      onClick={() => onModal('preview', row)}
                    />
                  )}
                  {permissions?.updated && (
                    <IconTooltipButton
                      id={`edit-${row._id}`}
                      disabled={isLoadingList}
                      title='Edit'
                      icon='pen'
                      onClick={() => onModal('edit', row)}
                    />
                  )}
                  {permissions?.updated && row.status === 'Published' && (
                    <IconTooltipButton
                      id={`notify-${row._id}`}
                      disabled={isLoadingList}
                      title='Send Email Notification'
                      icon='envelope'
                      onClick={() => onModal('send-notification', row)}
                    />
                  )}
                  {permissions.archived && (
                    <IconTooltipButton
                      id={`archive-${row._id}`}
                      disabled={isLoadingList}
                      title='Archive'
                      icon='archive'
                      onClick={() => onModal('archive', row)}
                    />
                  )}
                  {permissions.deleted && (
                    <IconTooltipButton
                      id={`delete-${row._id}`}
                      disabled={isLoadingList}
                      title='Delete'
                      icon='trash-alt'
                      onClick={() => onModal('delete', row)}
                    />
                  )}
                </div>
              )
            };
          })}
        loading={isLoadingList}
        totalRows={totalList}
        skip={skip}
        rowsPerPage={rowsPerPage}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false },
          ...columnsTable,
          {
            label: 'Log',
            key: 'log',
            align: 'center',
            className: 'text-center box-center',
            width: 120,
            show: true,
            hide: false
          },
          { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false }
        ]}
        nameModule='feed'
        labelNoRows="You don't have any feed yet"
      />
    </>
  );
};

export default List;
